import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Route, Switch } from "wouter";
import { DetailPage } from "./pages/DetailPage";
import { DevPage } from "./pages/DevPage";
import { DevSpotsPage } from "./pages/DevSpotsPage";
import { HowItWorksPage } from "./pages/HowItWorksPage";
import { MapPrototypePage } from "./pages/MapPrototypePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { OverviewPage } from "./pages/OverviewPage";
import { ParticlesTunePage } from "./pages/ParticlesTunePage";
import { RegionsPage } from "./pages/RegionsPage";
import { SocialExportPage } from "./pages/SocialExportPage";
import { SpotMapPrototypePage } from "./pages/SpotMapPrototypePage";
import { TestMarkersPage } from "./pages/TestMarkersPage";

export function App() {
  return (
    <>
      <Switch>
        <Route path="/" component={RegionsPage} />
        <Route path="/region/:regionId">
          {(params) => <OverviewPage params={params} />}
        </Route>
        <Route path="/spot/:id">
          {(params) => <DetailPage params={params} />}
        </Route>
        <Route path="/point/:lat/:lon">
          {(params) => <DetailPage params={params} />}
        </Route>
        <Route path="/how-it-works" component={HowItWorksPage} />
        <Route path="/dev" component={DevPage} />
        <Route path="/dev/spots" component={DevSpotsPage} />
        <Route path="/dev/social" component={SocialExportPage} />
        <Route path="/map-proto" component={MapPrototypePage} />
        <Route path="/spot-map-proto/:id">
          {(params) => <SpotMapPrototypePage params={params} />}
        </Route>
        <Route path="/particles-tune" component={ParticlesTunePage} />
        <Route path="/test/markers" component={TestMarkersPage} />
        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
      {/* Vercel Analytics + Speed Insights. Both auto-noop in dev. In
          prod they're cookie-less and GDPR-friendly. Speed Insights
          reports Core Web Vitals (the metric Google ranks on); Analytics
          handles page views and referrers. */}
      {import.meta.env.PROD && (
        <>
          <Analytics />
          <SpeedInsights />
        </>
      )}
    </>
  );
}
